import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Flex, Spin } from 'antd';
import { fetchRpmCarePlanDailyTaskList, setSelectedRpmPatient } from '../../../../../../../Redux/actions/rpmActions';
import CarePlanDailyTasksTable from './carePlanDailyTaskListsTable';

function Index() {
    const [currentPage, setCurrentPage] = useState(1);
    const { isLoading, careDailyTasksList, selectedRpmPatient } = useSelector((state) => state.rpm);
    const dispatch = useDispatch();

    useEffect(() => {
        const payload = {
            patientId: selectedRpmPatient.patientId,
            status: 1
        }
        dispatch(fetchRpmCarePlanDailyTaskList(payload));
    }, []);

    useEffect(() => {
        if (!selectedRpmPatient) {
            const rpmPatientJson = localStorage.getItem('rpmPatient');
            const rpmPatientObject = rpmPatientJson ? JSON.parse(rpmPatientJson) : null;
            if (rpmPatientObject) dispatch(setSelectedRpmPatient(rpmPatientObject));
        }
    }, []);


    return (
        <div>
            {
                isLoading && careDailyTasksList?.length === 0 ? (
                    <div className="flex items-center justify-center mt-[10%]">
                        <Flex align="center" gap="middle">
                            <Spin size="large" tip="Loading" />
                        </Flex>
                    </div>
                ) :
                    // careDailyTasksList?.length === 0 ?
                    //     (<div className="flex flex-col items-center justify-center">
                    //         <img src={nodatafound} alt="nodatafound" className="h-20 w-20" />
                    //         <p className="font-medium">No data found!!</p>
                    //     </div>
                    //     )
                    //     :
                    (
                        <div>
                            <CarePlanDailyTasksTable
                                data={careDailyTasksList}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                totalCount={careDailyTasksList?.length}
                            />
                        </div>
                    )
            }
        </div>
    )
}

export default Index;